import PageModule from "@eisinc/Overrides/Pages/SignInPage";

export * from "@eisinc/Overrides/Pages/SignInPage";

export default PageModule;
